import type { ReactNode } from "react";
import { Stepper, Step, StepLabel, Typography, Grid, useMediaQuery } from "@mui/material";
import { dateUtil } from "@sdeapps/react-core";
import statutMap, { unknownStatus } from "constants/SatutMap";
import type { StatutHistory } from "models/CommandeArticleFormModel";
import { useDebounce } from "use-debounce";

interface ArticleHistoriqueStepperProps {
  statutHistories?: Array<StatutHistory>;
}

function ArticleHistoriqueStepper({
  statutHistories,
}: Readonly<ArticleHistoriqueStepperProps>): ReactNode {
  const sizeIsSmall = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [debouncedIsSmallScreen] = useDebounce(sizeIsSmall, 500);

  return (
    <Grid size={12}>
      <Stepper alternativeLabel>
        {statutHistories?.map((x) => {
          const statut = statutMap.get(x.statut) ?? unknownStatus;
          return (
            <Step key={x.statut}>
              <StepLabel
                sx={{ ".MuiStepLabel-labelContainer .MuiStepLabel-label": { mt: 0.5 } }}
                icon={<statut.icon color={statut.color} fontSize="small" />}>
                <Typography sx={{ fontSize: 12 }} color={statut.color}>
                  {debouncedIsSmallScreen ? statut.smallLabel : statut.label}
                </Typography>
                <Typography sx={{ fontSize: 12 }}>
                  {dateUtil.format(x.date, "dd/MM/yyyy")}
                </Typography>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Grid>
  );
}

export default ArticleHistoriqueStepper;
